import { useEffect } from 'react';
import { unstable_usePrompt as usePrompt } from 'react-router-dom';

export const useConfirmBeforePageLeave = (
  isDirty: boolean,
  message = 'Changes that you made may not be saved?'
) => {
  usePrompt({ when: isDirty, message });
  useEffect(() => {
    const confirmLeave = (e: BeforeUnloadEvent) => {
      if (!isDirty) {
        console.log('false');
        return false;
      }
      e.preventDefault();
      e.returnValue = message;
      return true;
    };
    window.addEventListener('beforeunload', confirmLeave);
    return () => window.removeEventListener('beforeunload', confirmLeave);
  }, [isDirty, message]);
};
